export const backendurl = process.env.REACT_APP_BACKEND_URL || 'https://put-me-on.herokuapp.com/';
